import React, { type FunctionComponent, type MouseEvent, useState, useId } from 'react';
import { Menu, MenuItem, IconButton } from '@mui/material';

import config from 'config';

const MoreFavorites: FunctionComponent = () => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const isOpen = Boolean(anchorEl);
  const id = useId();
  const buttonId = `more-favorites-button-${id}`;
  const menuId = `more-favorites-menu-${id}`;

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div className="sl-collection-more-favorites">
      <IconButton
        id={buttonId}
        onClick={handleClick}
        aria-label="Open more favorites menu"
        aria-controls={isOpen ? menuId : undefined}
        aria-haspopup="true"
        aria-expanded={isOpen ? 'true' : undefined}
        className="sl-collection-more-favorites__button"
      >
        <svg version="1.1" height="18px" width="18px" viewBox="0 0 18 18">
          <circle fill="#333333" cx="9" cy="3" r="2" />
          <circle fill="#333333" cx="9" cy="9" r="2" />
          <circle fill="#333333" cx="9" cy="15" r="2" />
        </svg>
      </IconButton>
      <Menu
        id={menuId}
        anchorEl={anchorEl}
        open={isOpen}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        slotProps={{
          list: {
            'aria-labelledby': buttonId,
          },
        }}
      >
        <MenuItem
          component="a"
          href={`${config.surflineHost}/setup/favorite-surf-spots/add`}
          onClick={handleClose}
        >
          Add Favorites
        </MenuItem>
        <MenuItem
          component="a"
          href={`${config.surflineHost}/account/favorites`}
          onClick={handleClose}
        >
          Edit Favorites
        </MenuItem>
      </Menu>
    </div>
  );
};

export default MoreFavorites;
